import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class DynamicThemeClassService {

  private readonly themeName = environment.themeName;

 // Dynamic class name format: themeName_componentName_sectionPosition (e.g., townhaulperformance_subscribe_section1)
  generateClassName(divName: string): string {
    return `${this.themeName}_${divName}`
      .toLowerCase()
      .replace(/\s+/g, '_')
      .replace(/-/g, '_');
  }
}
